import HttpClient from "shared/repositories/HttpClient";
import { GetCampaignListResponse, SWRResponse } from "shared/types";
import useSWR from "swr";

const key = "/campaigns";

const fetcher = async () => {
  const response = await HttpClient.miror.get<GetCampaignListResponse>(
    "/campaigns"
  );
  return response.data;
};

export const useCampaignList = (): SWRResponse<GetCampaignListResponse> => {
  const { data, error, mutate } = useSWR(key, fetcher);

  return {
    campaigns: data?.campaigns,
    isLoading: !data && !error,
    isError: !!error,
    mutate,
  };
};
